import React from 'react';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Button from '@nubank/nuds-web/components/Button/Button';
import Link from '@nubank/nuds-web/components/Link/Link';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

import { trackInsuranceSimulation } from 'tracking/insurance/simulate';

import { BlockImage } from './styles/Image';

function SectionHero() {
  return (
    <Box
      tag="section"
    >
      <Grid row spacing="0x">
        <Grid
          row
          col={{ xs: 12, lg: 6 }}
          spacingVertical={{ xs: '12x', md: '12x', lg: '16x' }}
          spacingHorizontal={{ xs: '6x', md: '12x', lg: '16x' }}
          order={{ xs: 1, lg: 0 }}
          alignItems="center"
        >
          <Box alignContent="center">
            <Typography
              intlKey="INSURANCE.HERO.TITLE"
              variant="title"
              gutterBottom={1.5}
              intlValues={{ br: <br /> }}
            />
            <Typography
              intlKey="INSURANCE.HERO.SUBTITLE"
              variant="subtitle"
            />
            <Box
              display={{ xs: 'none', lg: 'flex' }}
              marginTop={{ lg: '6x' }}
              maxWidth="533px"
            >
              <Grid
                col={{ lg: 3 }}
                spacing="0x"
                spacingRight="4x"
              >
                <BlockImage
                  srcSet={{ lg: 'insurance-life-marketing-qr/insurance-life-marketing-link.jpg' }}
                  altIntlKey="INSURANCE.HERO.QR_ALT_TEXT"
                />
              </Grid>
              <Grid
                col={{ lg: 9 }}
                backgroundColor="white.dark"
                spacing="0x"
              >
                <Typography
                  padding="6x"
                  intlKey="INSURANCE.HERO.QR_TEXT"
                  intlValues={{ br: <br /> }}
                  variant="paragraph2"
                />
              </Grid>
            </Box>
            <Box display={{ lg: 'none' }}>
              <Grid spacing="0x">
                <Typography
                  intlKey="INSURANCE.HERO.LINK_TEXT"
                  variant="text2"
                  marginVertical="5x"
                />
                <Link
                  href="https://nuapp.nubank.com.br/bnVhcHA6Ly9pbnN1cmFuY2UvbGlmZS9tYXJrZXRpbmc/dXRtX3NvdXJjZT1zaXRlJnV0bV9tZWRpdW09c2VndXJvcyZ1dG1fY2FtcGFpZ249bGFuY2FtZW50b19udWJhbmtfdmlkYSZ1dG1fdGVybT1ib3RhbyZ1dG1fY29udGVudD1zaW11bGFy"
                >
                  <Button
                    onClick={trackInsuranceSimulation}
                    intlKey="INSURANCE.HERO.LINK_BUTTON"
                  />
                </Link>
              </Grid>
            </Box>
          </Box>
        </Grid>
        <Grid
          col={{ xs: 12, lg: 6 }}
          spacing="0x"
        >
          <BlockImage
            srcSet={{
              xs: 'woman-playing-with-her-kids/woman-playing-with-her-kids@xs.jpg',
              sm: 'woman-playing-with-her-kids/woman-playing-with-her-kids@sm.jpg',
              md: 'woman-playing-with-her-kids/woman-playing-with-her-kids@md.jpg',
              lg: 'woman-playing-with-her-kids/woman-playing-with-her-kids@lg.jpg',
              xl: 'woman-playing-with-her-kids/woman-playing-with-her-kids@xl.jpg',
            }}
            altIntlKey="INSURANCE.HERO.ALT_TEXT"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(SectionHero);
